import React, {FC, ReactNode} from 'react';
import {Col, Row} from 'antd';
import {RowProps} from 'antd/lib/row';

interface TopHeadingProps extends RowProps {
    left?: ReactNode;
    right?: ReactNode;
}

export const TopHeading: FC<TopHeadingProps> = ({left, right}) => {
    return (
        <Row align="middle" className={'section-title'}>
            {left && (
                <Col xs={24} sm={24} md={24} lg={14} xl={14}>
                    {left}
                </Col>
            )}
            {right && (
                <Col xs={24} sm={24} md={24} lg={10} xl={10} className="text-right">
                    {right}
                </Col>
            )}
        </Row>
    );
};
